import React from 'react';
import { Section } from './Section';
import { PackageSearch, ShieldCheck, CreditCard, RefreshCw, LineChart } from 'lucide-react';
export function NewWay() {
  const steps = [{
    num: '01',
    title: 'Producto y catálogo',
    desc: 'Estructuración comercial de categorías y fichas de producto para que el cliente entienda qué está comprando.',
    icon: <PackageSearch className="w-6 h-6 text-accent" data-id="element-300" />
  }, {
    num: '02',
    title: 'Conversión y confianza',
    desc: 'Diseño enfocado en reducir fricción, mostrar autoridad y guiar al usuario directo a la compra.',
    icon: <ShieldCheck className="w-6 h-6 text-accent" data-id="element-301" />
  }, {
    num: '03',
    title: 'Pagos y despacho',
    desc: 'Integración fluida de medios de pago locales y reglas de envío claras para evitar carritos abandonados.',
    icon: <CreditCard className="w-6 h-6 text-accent" data-id="element-302" />
  }, {
    num: '04',
    title: 'Seguimiento y recuperación',
    desc: 'Sistemas base para no perder al cliente que dudó, conectando WhatsApp y correos estratégicos.',
    icon: <RefreshCw className="w-6 h-6 text-accent" data-id="element-303" />
  }, {
    num: '05',
    title: 'Medición comercial',
    desc: 'Implementación de analítica para saber exactamente de dónde vienen las ventas y qué productos rinden mejor.',
    icon: <LineChart className="w-6 h-6 text-accent" data-id="element-304" />
  }];
  return <Section className="bg-slate-50" data-id="element-305">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-306">
        <span className="text-accent font-bold tracking-wider text-sm uppercase mb-3 block" data-id="element-307">
          El cambio de enfoque
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 mb-6" data-id="element-308">
          Una tienda online no debería construirse como una web. Debería
          construirse como un canal de ventas.
        </h2>
        <p className="text-lg text-slate-600" data-id="element-309">
          Antes de hablar de diseño, hay que entender qué necesita tu negocio
          para vender online con estructura desde el primer día. El enfoque
          correcto no parte por la estética, parte por la lógica comercial.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-310">
        {steps.map((step, i) => <div key={i} className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm relative overflow-hidden group hover:border-accent/30 transition-colors" data-id="element-311">
            <div className="absolute -right-4 -top-4 text-6xl font-heading font-extrabold text-slate-50 opacity-50 group-hover:text-accent/5 transition-colors" data-id="element-312">
              {step.num}
            </div>
            <div className="relative z-10" data-id="element-313">
              <div className="bg-accent/10 w-12 h-12 rounded-xl flex items-center justify-center mb-5" data-id="element-314">
                {step.icon}
              </div>
              <h3 className="font-heading font-bold text-navy-900 mb-3" data-id="element-315">
                {step.title}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed" data-id="element-316">
                {step.desc}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}